export default __webpack_public_path__ + "static/img_history@2x-b42268f0695b9c6abae720cf404e4b19.jpg";